module.exports = __webpack_public_path__ + "static/api-handler-0b75b0dc4f06ea58e22463e4408b1f69.jpg";